/* * @Author: Tango * @Date: 2020-04-15 19:29:30 * @Last Modified by: Tango * @Last Modified time: 2020-04-15 19:29:30
*/
<template>
  <div class="imageEditor">
    <a-spin :spinning="spinning">
      <a-row type="flex">
        <div class="step">
          <a-steps :current="currentProcess" type="navigation" :style="stepStyle" @change="changeStep">
            <a-step title="选择素材类型" description="">
              <div slot="icon" slot-scope="{ status }">
                <div :class="{ step_1_active: status === 'process', step_done: status === 'finish' }"></div>
              </div>
            </a-step>
            <a-step :disabled="processStatus < 1" title="上传素材" description="">
              <div slot="icon" slot-scope="{ status }">
                <div
                  :class="{
                    step_2: status === 'wait',
                    step_2_active: status === 'process',
                    step_done: status === 'finish',
                  }"
                ></div>
              </div>
            </a-step>
            <a-step :disabled="processStatus < 2" title="提交审核" description="">
              <div slot="icon" slot-scope="{ status }">
                <div
                  :class="{
                    step_3: status === 'wait',
                    step_3_active: status === 'process',
                    step_done: status === 'finish',
                  }"
                ></div>
              </div>
            </a-step>
          </a-steps>
          <a-button type="link" @click="showHelpModal">
            <!-- <span v-if="currentProcess === 0"> 如何填写素材信息？</span> -->
            <!-- <span v-if="currentProcess === 1"> 如何填写元素信息？</span> -->
            <span v-if="currentProcess === 2"> 如何提交？</span>
          </a-button>
        </div>
      </a-row>
      <div v-show="currentProcess === 0" class="step-box step-1">
        <a-row class="form">
          <a-col :xs="24" :md="24" :xl="24" :xxl="{ span: '24' }">
            <a-form :form="form" :label-col="{ span: 2 }" :wrapper-col="{ span: 12 }">
              <a-form-item label="素材类型">
                <a-radio-group
                  v-decorator="[
                    'type',
                    {
                      rules: [{ required: true, message: '请输入素材类型' }],
                      initialValue: material.category,
                    },
                  ]"
                  @change="typeChange"
                  style="height: 40px; line-height: 40px"
                >
                  <a-radio :value="'1'">
                    <span>场景</span>
                    <span class="help-box">
                      <i class="icon-left_help_16"></i>
                      <div class="tool-tips">
                        <p class="tool-text">
                          指一定时间、空间内的场合与环境画面，可简单理解为处于画面最底层的背景。如：一条街道，一个小村庄，一片风景。
                        </p>
                        <p class="tool-text">示例图：</p>
                        <img src="@/assets/img/img_help_sence.png" alt="" />
                      </div>
                    </span>
                  </a-radio>
                  <a-radio :value="'2'">
                    <span>贴图</span>
                    <span class="help-box">
                      <i class="icon-left_help_16"></i>
                      <div class="tool-tips">
                        <p class="tool-text">
                          可以贴在人物上，也可以贴在背景上的贴纸。如：特效图，爆炸效果，沙发，手机，车，一束花等等。
                        </p>
                        <p class="tool-text">示例图：</p>
                        <img src="@/assets/img/img_help_texture.png" alt="" />
                      </div>
                    </span>
                  </a-radio>
<!--                  <a-radio :value="'3'">-->
<!--                    <span>人设背景</span>-->
<!--                    <span class="help-box">-->
<!--                      <i class="icon-left_help_16"></i>-->
<!--                      <div class="tool-tips">-->
<!--                        <p class="tool-text">即漫想世界APP人设背景内衬托二次元虚拟形象的背景图。</p>-->
<!--                        <p class="tool-text">示例图：</p>-->
<!--                        <img src="@/assets/img/img_help_bg.png" alt="" />-->
<!--                      </div>-->
<!--                    </span>-->
<!--                  </a-radio>-->
                </a-radio-group>
              </a-form-item>
              <a-form-item
                :label="`${material.category == '1' || material.category == '2' ? '素材包名称' : '素材名称'}`"
                v-if="['1', '2', '3'].includes(material.category)"
              >
                <a-input
                  v-decorator="[
                    'title',
                    {
                      rules: [
                        {
                          required: true,
                          message: `${
                            material.category == '1' || material.category == '2' ? '素材包名称' : '素材名称'
                          }`,
                        },
                        { max: 8, message: '最多输入8个字符' },
                      ],
                      initialValue: material.package_title,
                    },
                  ]"
                  :placeholder="`请填写${
                    material.category == '1' || material.category == '2' ? '素材包名称' : '素材名称'
                  }`"
                  :max-length="maxLength"
                  @change="packetTitleChange"
                />
                <span class="ant-form-text" style="color: #999999; margin-left: 20px"> 最多输入8个字符 </span>
              </a-form-item>
              <a-form-item
                label="素材包封面"
                class="cover-item"
                v-if="material.category == '1' || material.category == '2'"
              >
                <div class="cover-box">
                  <upload-image
                    v-decorator="[
                      'package_image',
                      {
                        rules: [{ required: true, message: '请上传素材包封面' }],
                        initialValue: material.package_image,
                      },
                    ]"
                    :addWaterImage="true"
                    @onSuccess="materialOnSuccess"
                    :clip="true"
                    :clipOption="{
                      autoCropWidth: 300,
                      autoCropHeight: 300,
                      fixedNumber: [1, 1],
                    }"
                    :data="material"
                    :path="materialPath"
                    :bgImg="require('../../assets/img/img_upload_120@2x.png')"
                  >
                  </upload-image>
                </div>
                <div class="tips">
                  <p>尺寸：300*300像素</p>
                  <p>大小：小于200kb</p>
                  <p>格式：PNG、JPG、JPEG</p>
                </div>
              </a-form-item>
            </a-form>
          </a-col>
        </a-row>
        <a-row>
          <a-col :offset="2">
            <div class="step-btn-list">
              <a-button type="primary" class="next-step" @click="nextStep(0)"> 下一步 </a-button>
              <a-button class="save" @click="save()"> 保存并退出 </a-button>
            </div>
          </a-col>
        </a-row>
      </div>
      <div v-show="currentProcess === 1" class="step-box step-2">
        <a-row v-if="material.category != '3'">
          <a-col :xs="24" :md="24" :xl="24" :xxl="24">
            <a-form :label-col="{ span: 2 }" :wrapper-col="{ span: 22 }">
              <a-form-item label="批量上传" :required="true" class="cover-item" style="margin-bottom: 22px">
                <div class="cover-box">
                  <multi-upload-image
                    :limit="1024"
                    :accept="material.category == '1' ? '.jpeg,.jpg' : '.png'"
                    :path="elementPath"
                    :dataList="material.elementList"
                    :category="`${material.category}`"
                    @uploadSuccess="mutiUploadSuccess"
                    :isWaterMark="true"
                  >
                  </multi-upload-image>
                  <div
                    v-if="material.elementList.length >= 30"
                    class="upload-max"
                    @click="() => this.$message.error('已经上传30张素材了，不可以上传新素材了哦')"
                  ></div>
                </div>

                <div class="tips">
                  <p style="margin: 0px 0 20px">一次可添加多个素材哦~~</p>
                  <p>尺寸：{{ material.category === '1' ? `高度小于等于1600像素` : `1000×1000像素以内` }}</p>
                  <p>大小：小于1M</p>
                  <p>格式：{{ material.category === '1' ? `JPG、JPEG` : `PNG` }}</p>
                  <p>数量：每个素材包可传5~30张</p>
                </div>
              </a-form-item>
              <a-form-item label="填写元素信息" :required="true" v-if="material.elementList.length > 0">
                <a-col v-if="material.elementList.length > 0">
                  <a-row class="file-list" type="flex">
                    <div
                      v-for="(item, index) in material.elementList"
                      :key="index"
                      class="file-item"
                      :class="{ error: item.error.length > 0 }"
                    >
                      <div class="image-view">
                        <upload-image
                          :addWaterImage="true"
                          @onSuccess="elementOnSuccess"
                          :limit="1024"
                          :data="item"
                          :path="elementPath"
                          :checkSize="checkElementSize"
                          :accept="material.category === '1' ? '.jpeg,.jpg' : '.png'"
                          :bgImg="require('../../assets/img/material_bg.jpg')"
                        >
                        </upload-image>
                      </div>
                      <div class="name">
                        <a-input
                          type="text"
                          name="name"
                          placeholder="请输入素材名称"
                          id="name"
                          :max-length="maxLength"
                          v-model="item.title"
                          style="height: 32px; border-radius: 4px"
                          @change="elementTitleChange($event, item)"
                        ></a-input>
                      </div>
                      <div
                        class="close font_family icon-icon_close_spheric_24"
                        @click.stop="showDeleteConfirm(index)"
                      ></div>
                      <p class="error-tips" v-if="item.error">{{ item.error }}</p>
                    </div>
                  </a-row>
                </a-col>
              </a-form-item>
            </a-form>
          </a-col>
        </a-row>
        <!-- 人设背景上传 -->
        <a-row v-else>
          <a-col :xs="24" :md="24" :xl="24" :xxl="24">
            <a-form :label-col="{ span: 2 }" :wrapper-col="{ span: 12 }">
              <a-form-item label="上传背景" :required="true" class="cover-item" style="margin-bottom: 22px">
                <div class="cover-box">
                  <upload-image
                    v-decorator="[
                      'package_image',
                      {
                        rules: [{ required: true, message: '请上传人设背景' }],
                        initialValue: material.human_card.package_image,
                      },
                    ]"
                    :addWaterImage="true"
                    :limit="1024"
                    :bucketType="'5'"
                    @onSuccess="materialOnSuccess"
                    :checkSize="checkElementSize"
                    :data="material.human_card"
                    :clip="true"
                    :clipOption="{
                      autoCropWidth: 640,
                      autoCropHeight: 1138,
                      fixedNumber: [640, 1138],
                      zoom: 0.4,
                      info: false,
                    }"
                    :path="materialPath"
                    :accept="'.jpeg,.jpg'"
                    :bgImg="require('../../assets/img/img_upload_120@2x.png')"
                    class="card-upload"
                  >
                  </upload-image>
                </div>

                <div class="tips">
                  <p>尺寸：640*1138像素</p>
                  <p>格式：JPG、JPEG</p>
                  <p>大小：小于1M</p>
                  <p>
                    <span class="psd-card-icon">
                      <img src="@/assets/img/icon_psd_18_20@2x.png" alt="" />
                    </span>
                    <a
                      class="download-psd"
                      :href="`${
                        constv.APP_ENV == 'prod'
                          ? '/download/card_demo.psd'
                          : 'http://web-all.mindcomic.com/demo/zpace/download/card_demo.psd'
                      }`"
                      download="人设卡模板.psd"
                      >PSD模板下载</a
                    >
                  </p>
                </div>
              </a-form-item>
              <a-form-item label="预览效果">
                <div class="card-preview-list">
                  <div class="card-preview-item">
                    <div class="title">人设背景</div>
                    <div v-if="material.human_card.package_image" class="card-preview-img card_1">
                      <img style="z-index: 2" src="@/assets/img/img_card_top_2.png" alt="" srcset="" />
                      <img
                        style="z-index: 1"
                        :src="`${constv.QINIU_IMAGE_QNC_CDN_URL}${material.human_card.package_image}`"
                        alt=""
                      />
                    </div>
                    <div v-else>
                      <img src="@/assets/img/img_card_default.png" alt="" />
                    </div>
                  </div>
                  <div class="card-preview-item">
                    <div class="title">人设卡片</div>
                    <div v-if="material.human_card.package_image" class="card-preview-img card_2">
                      <img style="z-index: 1" src="@/assets/img/img_card_0.png" alt="" srcset="" />
                      <div class="card-display">
                        <img
                          style="z-index: 2"
                          :src="`${constv.QINIU_IMAGE_QNC_CDN_URL}${material.human_card.package_image}`"
                          alt=""
                        />
                      </div>
                      <img style="z-index: 3" src="@/assets/img/img_card_2.png" alt="" srcset="" />
                    </div>
                    <div v-else>
                      <img src="@/assets/img/img_card_preview_default.png" alt="" />
                    </div>
                  </div>
                </div>
              </a-form-item>
            </a-form>
          </a-col>
        </a-row>
        <a-row>
          <a-col :offset="2">
            <div class="step-btn-list">
              <a-button type="primary" class="next-step" @click="prevStep(1)"> 上一步 </a-button>
              <a-button type="primary" class="next-step" @click="nextStep(1)"> 下一步 </a-button>
              <a-button class="save" @click="save()"> 保存并退出 </a-button>
            </div>
          </a-col>
        </a-row>
      </div>
      <div v-show="currentProcess === 2" class="step-box step-2">
        <a-row>
          <a-col>
            <a-form :form="form2" :label-col="{ span: 4 }" :wrapper-col="{ span: 12 }">
              <a-form-item label="本网站是否是此图第一次发布网站">
                <a-radio-group
                  v-decorator="[
                    'is_first_publish',
                    {
                      rules: [{ required: true, message: '请勾选' }],
                      initialValue: material.is_first_publish,
                    },
                  ]"
                  @change="isFirstChange"
                >
                  <a-radio :value="'2'">是</a-radio>
                  <a-radio :value="'1'">否</a-radio>
                </a-radio-group>
              </a-form-item>
              <a-form-item v-if="material.is_first_publish === '1'" label="首发时间">
                <a-date-picker
                  v-decorator="[
                    'first_publish_time',
                    {
                      rules: [
                        {
                          required: material.is_first_publish === '1',
                          message: '请输入首发时间',
                        },
                      ],
                      initialValue: material.first_publish_time
                        ? moment(material.first_publish_time, 'YYYY-MM-DD')
                        : null,
                    },
                  ]"
                  placeholder="请选择首发时间"
                  @change="publishTimeChange"
                />
              </a-form-item>
              <a-form-item v-if="material.is_first_publish === '1'" label="首发网站">
                <a-input
                  v-decorator="[
                    'first_publish_website',
                    {
                      rules: [
                        {
                          required: material.is_first_publish === '1',
                          message: '请填写首发网站的网址',
                        },
                      ],
                      initialValue: material.first_publish_website,
                    },
                  ]"
                  placeholder="请填写首发网站的网址"
                  @change="websiteChange"
                />
              </a-form-item>
              <a-form-item label="建议零售价：">
                  <a-input class="sale-input" type="number"
                    v-decorator="[
                      'recommended_retail_price',
                      {
                        rules: [{ required: true, message: '请填写' }],
                        initialValue: material.recommended_retail_price,
                      },
                    ]" @change="priceChange"/>钻石
              </a-form-item>
              <a-form-item label="选择分成比例：">
                  <a-radio-group
                    class="rate-group"
                    v-decorator="[
                      'copyright_type',
                      {
                        rules: [{ required: true, message: '请勾选'  }],
                        initialValue: material.copyright_type,
                      },
                    ]"
                    @change="copyrightTypeChange"
                  >
                    <a-radio :value="'1'"><span class="radio-label">版权归画师-非独家</span>画师分成70%</a-radio>
                    <a-radio :value="'2'"><span class="radio-label">版权归画师-独家</span>画师分成80%</a-radio>
                    <a-radio :value="'3'"><span class="radio-label">版权归漫想</span>画师分成90%</a-radio>
                  </a-radio-group>
              </a-form-item>
              <a-row style="margin-bottom: 12px">
                <a-col offset="4">
                  <a-form-item
                    :wrapper-col="{
                      xs: {
                        span: 24,
                        offset: 0,
                      },
                      sm: {
                        span: 24,
                        offset: 0,
                      },
                    }"
                    style="margin-bottom: 0"
                  >
                    <a-checkbox
                      v-decorator="[
                        'agreement',
                        {
                          valuePropName: 'checked',
                        },
                      ]"
                    >
                      本人确认仔细阅读理解
                      <a @click.stop="showAgreementModal = true"> 《原创协议》 </a>
                      的全部内容，同意接受上述协议的全部内容
                    </a-checkbox>
                  </a-form-item>
                </a-col>
              </a-row>
            </a-form>
          </a-col>
        </a-row>
        <a-row>
          <a-col :offset="4">
            <div class="step-btn-list">
              <a-button type="primary" class="next-step" @click="prevStep(2)"> 上一步 </a-button>
              <a-button type="primary" class="next-step" @click="submit">发布</a-button>
              <a-button class="save" @click="save()"> 保存并退出 </a-button>
            </div>
          </a-col>
        </a-row>
      </div>
      <a-progress slot="indicator" type="circle" :percent="percent" v-if="percent > 0" />
      <a-modal
        :visible="showErrorModal"
        :closable="false"
        :mask-closable="false"
        @ok="handleErrorOk"
        @cancel="handleErrorCancel"
      >
        <p style="text-align: center">
          <a-icon type="close-circle" :style="{ fontSize: '26px', color: 'red' }" />
        </p>
        <p style="text-align: center">{{ ModalText }}，提交失败</p>
        <p style="text-align: center">是否重新提交？</p>
      </a-modal>
      <a-modal v-model="showAgreementModal" :footer="null">
        <div>
          <p
            style="
              line-height: 25pt;
              margin: 0pt 0pt 10pt;
              orphans: 0;
              text-align: center;
              text-indent: 21pt;
              widows: 0;
            "
          >
            <span style="font-family: 微软雅黑; font-size: 12pt; font-weight: bold">原创声明</span>
          </p>
          <p
            style="
              line-height: 25pt;
              margin: 0pt 0pt 10pt;
              orphans: 0;
              text-align: justify;
              text-indent: 21pt;
              widows: 0;
            "
          >
            <span style="font-family: 微软雅黑; font-size: 12pt"
              >本人郑重声明:所上传/提供的作品是本人独立创作完成的成果。除本人特别标注来源于他人的部分外,本作品不包含任何其他个人或集体已经发表或完成的成果/作品。</span
            >
          </p>
        </div>
      </a-modal>
      <a-modal v-model="showHelp" :footer="null" width="1024px" centered>
        <div v-if="currentProcess === 0">
          <div class="help-content">
            <h2 class="title">如何填写素材信息？</h2>
            <p class="desc">
              填写素材名称，名称不超过8个字，上传素材图片的封面（尺寸：300*300像素，大小：小于200kb，格式jpg/png），素材类型选中场景/贴图，确认无误点击下一步
            </p>
            <h2 class="title">什么是场景？</h2>
            <p class="desc">
              一张完整的图片由多个物体组成，其中处于图片最底层的<span class="primary">背景</span
              >称之为场景，可以是一个街道，一个小村庄，一片天空，一片风景，凡是打算拿来当背景的图都可以叫做场景噢！
            </p>
            <div class="img-list">
              <div class="img">
                <img src="../../assets/img/0.jpg" alt="" />
              </div>
              <div class="img">
                <img src="../../assets/img/1.jpg" alt="" />
              </div>
              <div class="img">
                <img src="../../assets/img/3.jpg" alt="" />
              </div>
            </div>
            <h2 class="title">什么是贴图？</h2>
            <p class="desc">
              可以贴在人物上，也可以贴在背景上的贴纸称之为贴图，比如特效图，爆炸效果，沙发，手机，车，一束花等等
            </p>
            <div class="img-list">
              <div class="img">
                <img src="../../assets/img/4.png" alt="" />
              </div>
              <div class="img">
                <img src="../../assets/img/5.png" alt="" />
              </div>
              <div class="img">
                <img src="../../assets/img/6.png" alt="" />
              </div>
              <div class="img">
                <img src="../../assets/img/7.png" alt="" />
              </div>
              <div class="img">
                <img src="../../assets/img/8.png" alt="" />
              </div>
            </div>
          </div>
        </div>
        <div v-if="currentProcess === 1">
          <div class="help-content">
            <img src="../../assets/img/9.png" alt="" />
          </div>
        </div>
        <div v-if="currentProcess === 2">
          <div class="help-content">
            <h2 class="title">如何提交成功？</h2>
            <p class="desc">
              ①如果本网站是所上传素材的 <span class="primary">首发平台</span> ，点击选项
              <span class="primary">是</span> 。如果所上传素材在其他平台发布过，点击选项
              <span class="primary">否</span>
              ，然后填写首发时间（指素材第一次发布的时间）首发平台（指素材第一次发布的平台
            </p>
            <p class="desc">②勾选原创协议后，可以选择下方的提交（指立刻发布素材）或者保存（素材信息等存为草稿形式）</p>
          </div>
        </div>
      </a-modal>
      <a-modal
        v-model="showHelpUpload"
        :footer="null"
        class="showHelpUpload"
        :maskClosable="false"
        width="760px"
        :bodyStyle="{ padding: '24px 24px 0 24px' }"
        centered
      >
        <span class="close-modal-icon" slot="closeIcon"></span>
        <div class="title" slot="title">4步完成素材上传</div>
        <div class="content">
          <img src="@/assets/img/help_gif.gif" alt="" />
          <p style="margin: 23px 0 0; line-height: 28px">步骤1：点击上传素材按钮</p>
          <p>步骤2：填写素材包信息</p>
          <p>步骤3：批量上传素材图片</p>
          <p>步骤4：确认素材信息，点击提交</p>
        </div>
        <div class="btn-list">
          <a-button
            :disabled="!agree.status || !agree.check"
            type="primary"
            @click="showHelpUpload = false"
            class="login-form-button"
            style="width: 200px; height: 50px; border-radius: 8px; margin: 0px 0 40px 0px"
          >
            {{ agree.status ? '好的' : `${agree.time}s` }}
          </a-button>
        </div>
      </a-modal>
    </a-spin>
  </div>
</template>

<script>
import moment from 'moment'
import { mapActions } from 'vuex'
import UploadImage from '@/components/Zpace/UploadImage/UploadImage'
import MultiUploadImage from '@/components/Zpace/UploadImage/MultiUploadImage'
import { getBase64, getRandom, setLocalStorage, getLocalStorage, clearLocalStorage } from '@/utils/util.js'
import * as qiniu from 'qiniu-js'

export default {
  components: { UploadImage, MultiUploadImage },
  filters: {
    actionDirection (val) {
      switch (val) {
        case 0:
          return '正前方'
        case 1:
          return '右方'
        case 2:
          return '正后方'
      }
    }
  },
  data () {
    return {
      list: [], // 素材列表
      materialPath: 'resources/cloud/title_image_web/',
      maxLength: 8,
      spinning: false,
      loading: false,
      visible: false,
      form1: this.$form.createForm(this),
      form: this.$form.createForm(this),
      form2: this.$form.createForm(this),
      type: 'fz', // 素材类型
      currentProcess: 0,
      stepStyle: {
        marginBottom: '0px',
        width: '800px'
      },
      material: {
        // 素材
        package_title: '',
        package_image: '',
        category: '',
        loading: false,
        percent: 0,
        elementList: [],
        is_first_publish: '',
        first_publish_time: '',
        first_publish_website: '',
        human_card: {
          package_image: '',
          loading: false,
          percent: 0,
          image: ''
        }
      },
      initMaterial: {},
      delConfirm: false,
      delIndex: '',
      processStatus: 0,
      percent: 0,
      timer: null,
      showErrorModal: false,
      ModalText: '',
      backUrl: '',
      clickSaveBtn: false, // 为true 时跳转地址不用弹窗
      showAgreementModal: false,
      showHelp: false,
      showHelpUpload: false,
      package_id: '',
      limit: 1024,
      elementIndex: '0',
      uploadTimer: null,
      agreeTimer: null,
      agree: {
        time: 3,
        status: false,
        check: true
      }
    }
  },
  watch: {
    showAuthentication (val) {
      this.checkHelpModal()
    }
  },
  computed: {
    showAuthentication () {
      return this.$store.state.texture.helpModalStatus
    },
    elementPath () {
      let path = ''
      if (this.material.category === '1') {
        // 如果是场景素材  上传路径是scene_web
        path = 'resources/scene_web/'
      } else if (this.material.category === '2') {
        // 如果是贴图素材 上传路径是material_web
        path = 'resources/material_web/'
      }

      return path
    },
    getQiniuUploadToken () {
      return this.$store.state.texture.token
    },
    userInfo () {
      return this.$store.state.user.info
    }
  },
  async created () {
    this.package_id = this.$route.query.id
    if (this.package_id) {
      // 如果是修改 先获取之前保存的数据
      const params = {
        id: this.package_id
      }
      this.spinning = true
      const res = await this.$api.texture.getTextureInfo(params)
      console.log(res)
      if (res.status === 'ok') {
        const {
          category,
          package_image,
          package_title,
          is_first_publish,
          first_publish_time,
          first_publish_website,
          watermark_image,
          res_data: elementList = []
        } = res.data[0]
        if (elementList.length > 0) {
          elementList.forEach((item, index) => {
            elementList[index].error = ''
            elementList[index].loading = false
            elementList[index].percent = 0
          })
        }
        this.material = {
          category,
          package_image,
          watermark_image,
          package_title,
          is_first_publish,
          first_publish_time,
          first_publish_website,
          elementList,
          human_card: {
            package_image: '',
            watermark_image: '',
            image: ''
          }
        }

        if (category == '3') {
          this.material.package_image = ''
          this.material.watermark_image = ''
          this.material.human_card.package_image = package_image
          this.material.human_card.watermark_image = watermark_image
          this.material.human_card.image = package_image
        } else {
          this.material.image = package_image
        }

        this.spinning = false
        // 从缓存加载数据 默认恢复到第一步
        this.loadDataFromLocal()

        // 兼容ie
        this.form.setFieldsValue({
          title: this.material.package_title,
          package_image: this.material.package_image
        })
      } else {
        this.clickSaveBtn = true
        this.$router.push({ path: '/manage/chartlet' })
      }
    }

    this.initMaterial = JSON.parse(JSON.stringify(this.material)) // 深拷贝
    // this.initMaterial = Object.assign({}, this.material) // 浅拷贝
  },
  mounted () {
    this.burry('16')
    this.backUrl = this.$route.query.backUrl || ''
    const that = this
    const materialData = this.getMaterialData()
    console.log(materialData)
    if (materialData && !this.package_id) {
      // 异常关闭存储
      this.$confirm({
        centered: true,
        content: '有未完成操作',
        onOk () {
          that.material = materialData
          that.loadDataFromLocal()
        },
        cancelText: '取消',
        okText: '继续',
        onCancel () {
          that.clearMaterialLocal()
        }
      })
    }
    this.checkHelpModal()
  },
  methods: {
    ...mapActions(['getQiniuToken']),
    checkHelpModal () {
      const list = sessionStorage.getItem('list')
      if (list == 0 && !localStorage.getItem(`isFirstUpload_${this.userInfo.user_id}`)) {
        this.showHelpUpload = true
        this.agreeTimer = setInterval(() => {
          this.agree.time -= 1
          if (this.agree.time === 0) {
            this.agree.status = true
            this.agree.time = 3
            clearInterval(this.agreeTimer)
          }
        }, 1000)
        localStorage.setItem(`isFirstUpload_${this.userInfo.user_id}`, this.userInfo.user_id)
      }
    },
    moment,
    // 生成图片名字
    name () {
      return getRandom(4) + Math.floor(new Date().getTime() / 1000) + getRandom(4)
    },
    // 如果本地有数据 恢复上次记录
    loadDataFromLocal () {
      if (this.material.package_title) {
        this.processStatus = 0
        this.currentProcess = 0
      }
    },
    // 上传步骤
    processChange (currentProcess) {
      this.currentProcess = currentProcess
    },
    // 上传封面图完成
    async materialOnSuccess (response, filename, file, data) {
      if (this.material.category == '3') {
        this.material.human_card.package_image = response.key
      } else {
        this.material.package_image = response.key
        this.form.setFieldsValue({
          package_image: this.material.package_image
        })
      }
      this.saveMaterialData()
      // 上传水印图片 最终水印地址 http://wm.mindcomic.com/resources/cloud/title_image_web/fjsa1594015760ensz.png=zpace_wm_muti
      // data.originFileObj = file
      // // 添加水印
      // await this.addWaterMark(data, this.materialPath)
    },
    // 元素上传成功
    async elementOnSuccess (response, filename, file, data) {
      data.image = response.key
      const img = new Image()
      getBase64(file, (oimg) => {
        img.src = oimg
        img.onload = () => {
          data.width = img.width
          data.height = img.height
        }
      })
      this.saveMaterialData()
      // // 上传水印图片
      // data.originFileObj = file
      // await this.addWaterMark(data, this.elementPath)
    },
    // 素材类型切换
    typeChange (e) {
      this.material.category = e.target.value
      if (e.target.value == '3') {
        this.material.package_image = ''
        this.material.image = ''
        this.material.watermark_image = ''
      }
      this.saveMaterialData()
    },
    // 获取后缀名
    geteExtension (url) {
      var ext = null
      var name = url.toLowerCase()
      var i = name.lastIndexOf('.')
      if (i > -1) {
        ext = name.substring(i)
      }
      return ext
    },
    // 根据图片后缀名判断素材类型（贴图，场景）
    checkImgType (url) {
      const arr = ['.jpg', '.jpeg', '.jpe', '.jfif', '.jif']
      const ext = this.geteExtension(url)
      console.log(ext, 'ext')
      if (['.png'].includes(ext)) {
        return '2'
      } else if (arr.includes(ext)) {
        return '1'
      }
    },
    // 点击下一步
    nextStep (step) {
      switch (step) {
        case 0:
          this.form.validateFields((error, values) => {
            if (error) {
              console.log(error)
              this.burry('18')
              return
            }

            if (
              this.material.category !== '' &&
              this.material.elementList[0] &&
              this.material.elementList[0].image &&
              this.material.category !== this.checkImgType(this.material.elementList[0].image)
            ) {
              this.$confirm({
                centered: true,
                content: '修改类型会删除之前上传的素材，是否继续？',
                onOk: () => {
                  this.material.elementList = []
                  this.material.package_title = values.title
                  this.currentProcess = step - 0 + 1
                  this.processStatus = 1
                  this.saveMaterialData()
                },
                cancelText: '取消',
                okText: '确定',
                onCancel () { }
              })
            } else {
              this.burry('17')
              this.material.package_title = values.title
              this.currentProcess = step - 0 + 1
              this.burry('19')
              this.processStatus = 1
            }
          })
          break
        case 1: {
          if (this.material.category != '3') {
            let i = 0
            let imgNum = 0
            this.material.elementList.forEach((item, index) => {
              // 检查昵称有没有填完
              if (item.title === '' && item.error === '') {
                this.burry('21')
                this.material.elementList[index].error = '昵称填完整才可以提交哦~'
                this.material.elementList[index].errorType = '4'
                i++
              }
              if (item.image === '') {
                imgNum++
              }
            })

            if (i > 0) {
              this.burry('21')
              this.$message.error('每个素材都需要填充名称后才可以进行下一步哦')
              return false
            }
            if (imgNum > 0) {
              this.burry('21')
              this.$message.error('每个素材都需要填充图片后才可以进行下一步哦')
              return false
            }

            // 找出有错误数量
            const errList = this.material.elementList.filter((item) => {
              return item.error !== ''
            })

            if (errList.length > 0) {
              // 如果有错误，则返回
              this.burry('21')
              return false
            }

            // 如果小于五个
            const num = this.material.elementList.length
            if (num < 5) {
              this.burry('21')
              this.$message.error('每个素材包最少上传5个素材哦')
              return
            }
          } else {
            if (!this.material.human_card.package_image) {
              this.$message.error('请上传人设背景')
              return
            }
          }

          this.currentProcess = step - 0 + 1
          this.burry('20')
          this.burry('23')
          this.processStatus = 2
          break
        }
      }
    },
    prevStep (step) {
      this.burry('22')
      this.burry('27')
      this.currentProcess = step - 0 - 1
    },
    // 批量上传
    // async onMultiUpload (file) {
    //   console.log(this.material.elementList.length)
    //   if (this.material.elementList.length >= 30) {
    //     if (this.uploadTimer) {
    //       clearTimeout(this.uploadTimer)
    //     }
    //     this.uploadTimer = setTimeout(() => {
    //       this.uploadTimer = null
    //       this.$message.error('已经上传30张素材了，不可以上传新素材了哦')
    //     }, 500)
    //     return false
    //   }
    //   this.material.elementList.push(
    //     Object.assign(
    //       {
    //         width: '',
    //         height: '',
    //         loading: false,
    //         percent: 0,
    //         title: '', // file.name.split('.')[0].substring(0, 8)
    //         error: '',
    //         errorType: '',
    //         image: '',
    //         watermark_image: ''
    //       },
    //       file
    //     )
    //   )

    //   const last = this.material.elementList.length - 1
    //   const typeList = this.material.category === '1' ? '.jpeg,.jpg' : '.png'
    //   const isJpgOrPng = typeList.split(',').findIndex((item) => {
    //     return file.type.indexOf(item.replace(/\./g, '')) > -1
    //   })
    //   if (isJpgOrPng < 0) {
    //     this.material.elementList[last].error = `素材格式有误，请重新上传: 格式`
    //     this.material.elementList[last].errorType = '1'
    //     return
    //   }

    //   if (this.limit) {
    //     const isLimit = file.size / 1024 < this.limit
    //     if (!isLimit) {
    //       this.material.elementList[last].error = `素材格式有误，请重新上传: 大小`
    //       this.material.elementList[last].errorType = '2'
    //       return
    //     }
    //   }
    //   this.checkElementSize(this.material.elementList[last].originFileObj, this.material.elementList[last])
    //     .then(async (res) => {
    //       await this.postImage(this.material.elementList[last], this.elementPath)
    //       await this.addWaterMark(this.material.elementList[last], this.elementPath)
    //       this.saveMaterialData()
    //     })
    //     .catch((err) => {
    //       console.log(err)
    //     })
    // },
    // 上传到七牛
    async postImage (file, path) {
      const sendData = {
        action: 'upload',
        bucketType: '1'
      }
      // 获取七牛上传token
      await this.getQiniuToken(sendData)

      const params = {
        token: this.$store.state.texture.token,
        key: `${path}${this.name()}.${file.type.split('/')[1]}`
      }
      file.loading = true
      // 上传到七牛 拿到图片地址
      const observable = qiniu.upload(file.originFileObj, params.key, params.token)
      observable.subscribe({
        next: (result) => {
          // 主要用来展示进度
          file.percent = Math.round(result.total.percent).toFixed(0)
          if (file.percent === 100) {
            file.loading = false
          }
          // this.$emit('onChange', this.file)
        },
        error: () => {
          this.$message.error('上传图片失败')
        },
        complete: async (response) => {
          file.image = response.key // 返回的路径
          file.loading = false
          this.saveMaterialData()
        }
      })
    },
    // 添加水印
    async addWaterMark (file, path) {
      // 生成水印名字
      const waterMarkKey = `${path}${this.name()}.${file.originFileObj.type.split('/')[1]}`
      // 上传水印图片
      const sendData = {
        action: 'upload',
        bucketType: '2'
      }
      await this.getQiniuToken(sendData)

      // 上传到七牛 拿到图片地址
      const observable = qiniu.upload(file.originFileObj, waterMarkKey, this.$store.state.texture.token)
      observable.subscribe({
        next: (result) => {
          // 主要用来展示进度
        },
        error: () => {
          this.$message.error('上传水印图片失败')
        },
        complete: (response) => {
          file.watermark_image = response.key // 返回的路径
          this.saveMaterialData()
        }
      })
    },
    changeStep (step) {
      if (
        this.material.category !== '' &&
        this.material.elementList[0] &&
        this.material.elementList[0].image &&
        this.material.category !== this.checkImgType(this.material.elementList[0].image)
      ) {
        // 如果已经上传过元素再切换类型 会弹出提示
        this.$confirm({
          centered: true,
          content: '修改类型会删除之前上传的素材，是否继续？',
          onOk: () => {
            this.material.elementList = []
            this.currentProcess = step
            this.processStatus = 1
            this.saveMaterialData()
          },
          cancelText: '取消',
          okText: '确定',
          onCancel () { }
        })
      } else {
        this.currentProcess = step
      }
    },
    // 删除元素
    delElement () {
      this.material.elementList.splice(this.delIndex, 1)
      this.saveMaterialData()
    },
    showDeleteConfirm (index) {
      this.delIndex = index
      const self = this
      this.$confirm({
        centered: true,
        content: '确定删除该素材',
        onOk () {
          self.delElement()
        },
        cancelText: '取消',
        okText: '确定',
        onCancel () { }
      })
    },
    // 发布
    submit () {
      this.form2.validateFields(async (error, values) => {
        if (error) {
          this.burry('25')
          return
        }
        if (!values.agreement) {
          this.burry('25')
          this.$message.error('请阅读并勾选协议')
          return
        }

        this.spinning = true
        this.percent = 0
        this.timer = setInterval(() => {
          this.percent += 10
          if (this.percent >= 90) clearInterval(this.timer)
        }, 100)
        this.material.is_first_publish = values.is_first_publish
        this.material.first_publish_website = values.first_publish_website
        const res_data = []
        this.material.elementList.forEach((item) => {
          const { title, image, width, height, watermark_image } = item
          res_data.push({ title, image, width, height, watermark_image })
        })
        const sendData = {
          watermark_image: this.material.human_card.watermark_image || this.material.watermark_image,
          package_title: this.material.package_title,
          package_image: this.material.human_card.package_image || this.material.package_image,
          category: this.material.category,
          res_data: JSON.stringify(res_data),
          is_first_publish: this.material.is_first_publish,
          first_publish_time: this.material.first_publish_time,
          first_publish_website: this.material.first_publish_website,
          status: '1',
          id: this.package_id,
          recommended_retail_price: this.material.recommended_retail_price,
          copyright_type: this.material.copyright_type,
          price_type: 1,
        }

        await this.$api.texture
          .submitTextureEdit(sendData)
          .then((res) => {
            if (res.status && res.status === 'error') {
              this.burry('25')
              this.ModalText = res.message.message
              this.showErrorModal = true
            } else {
              this.burry('24')
              this.percent = 100
              this.$message.success('提交素材成功！')
              this.clearMaterialLocal()
              this.clickSaveBtn = true
              this.$router.push('/manage/chartlet')
            }
          })
          .catch((err) => {
            this.burry('25')
            clearInterval(this.timer)
            this.spinning = false
            if (err && err.response) {
              switch (err.response.status) {
                case 400:
                  err.message = '请求错误(400)'
                  break
                case 401:
                  err.message = '未授权，请重新登录(401)'
                  break
                case 403:
                  err.message = '拒绝访问(403)'
                  break
                case 404:
                  err.message = '请求出错(404)'
                  break
                case 408:
                  err.message = '请求超时(408)'
                  break
                case 500:
                  err.message = '服务器错误(500)'
                  break
                case 501:
                  err.message = '服务未实现(501)'
                  break
                case 502:
                  err.message = '网络错误(502)'
                  break
                case 503:
                  err.message = '服务不可用(503)'
                  break
                case 504:
                  err.message = '网络超时(504)'
                  break
                case 505:
                  err.message = 'HTTP版本不受支持(505)'
                  break
                default:
                  err.message = `连接出错(${err.response.status})!`
              }
            } else {
              err.message = '连接服务器失败!'
            }
            this.ModalText = err.message
            this.showErrorModal = true
          })
      })
    },
    // 保存数据
    async save (path = '') {
      this.burry('26')
      this.spinning = true

      this.timer = setInterval(() => {
        this.percent = 0
        this.percent += 10
        if (this.percent >= 90) clearInterval(this.timer)
      }, 50)
      const res_data = []
      this.material.elementList.forEach((item) => {
        const { title, image, width, height, watermark_image } = item
        res_data.push({ title, image, width, height, watermark_image })
      })
      const sendData = {
        watermark_image: this.material.human_card.watermark_image || this.material.watermark_image,
        package_title: this.material.package_title,
        package_image: this.material.human_card.package_image || this.material.package_image,
        category: this.material.category,
        res_data: JSON.stringify(res_data),
        is_first_publish: this.material.is_first_publish,
        first_publish_time: this.material.first_publish_time,
        first_publish_website: this.material.first_publish_website,
        status: '0',
        id: this.package_id
      }

      const res = await this.$api.texture.submitTextureEdit(sendData)
      if (res.status === 'ok') {
        this.percent = 100
        this.spinning = false
        this.$message.success('保存素材成功！')
        this.clickSaveBtn = true
        this.clearMaterialLocal()
        if (path) {
          this.$router.push({ path: path })
        } else {
          this.$router.push({ path: '/manage/chartlet' })
        }
      } else {
        this.spinning = false
        clearInterval(this.timer)
        // this.$message.error(res.message.message)
      }
    },
    isFirstChange (e) {
      this.material.is_first_publish = e.target.value
      if (e.target.value === 1) {
        this.material.first_publish_time = ''
        this.material.first_publish_website = ''
      }
      this.saveMaterialData()
    },
    copyrightTypeChange (e) {
      this.material.copyright_type = e.target.value
      this.saveMaterialData()
    },
    priceChange (e) {
      this.material.recommended_retail_price = e.target.value
      this.saveMaterialData()
    },
    packetTitleChange (e) {
      this.material.package_title = e.target.value
      this.saveMaterialData()
    },
    websiteChange (e) {
      this.material.first_publish_website = e.target.value
      this.saveMaterialData()
    },
    publishTimeChange (date, dateString) {
      this.material.first_publish_time = dateString
      this.saveMaterialData()
    },
    elementTitleChange (e, item) {
      item.title = e.target.value
      if (e.target.value !== '' && item.errorType === '4') {
        item.error = ''
      }
      this.saveMaterialData()
    },
    // 保存数据到本地
    saveMaterialData () {
      setLocalStorage(`material_${this.userInfo.user_id}`, this.material)
    },
    // 清楚本地素材数据
    clearMaterialLocal () {
      clearLocalStorage(`material_${this.userInfo.user_id}`)
    },
    getMaterialData () {
      return getLocalStorage(`material_${this.userInfo.user_id}`)
    },
    // 提交错误弹窗确认
    handleErrorOk () {
      this.showErrorModal = false
      this.spinning = false
      this.submit()
    },
    // 提交错误弹窗取消
    handleErrorCancel () {
      this.showErrorModal = false
      this.spinning = false
    },
    // 打开帮助页面
    showHelpModal () {
      this.showHelp = true
    },
    backMange () {
      this.$router.push({ path: '/manage/chartlet' })
    },
    // 上传前检测尺寸是否符合
    checkElementSize (file, scopeData) {
      return new Promise((resolve, reject) => {
        getBase64(file, (oImg) => {
          const img = new Image()
          img.src = oImg
          img.onload = () => {
            scopeData.width = img.width
            scopeData.height = img.height
            if (this.material.category === '1') {
              // 如果是场景 height 小于1600
              if (img.height > 1600) {
                this.$message.error('只能上传高度小于1600像素的图片')

                const err = 'err'
                reject(err)
              } else {
                resolve('ok')
              }
            } else if (this.material.category === '2') {
              // 如果是贴图  width < 640 && height < 800
              // if (img.width > 640 || img.height > 800) {
              if (img.width > 1000 || img.height > 1000) {
                this.$message.error('只能上传1000×1000像素以内的图片')

                const err = 'err'
                reject(err)
              } else {
                resolve('ok')
              }
            } else if (this.material.category == '3') {
              // 如果是人设背景 640*1138
              if (img.width != 640 || img.height != 1138) {
                this.$message.error('只能上传宽度等于640像素，高度等于1138像素的图片')

                const err = 'err'
                reject(err)
              } else {
                resolve('ok')
              }
            }
          }
        })
      })
    },
    checkFirst (rule, value, callback) {
      if (value === '1' || value === '2') {
        callback()
      } else {
        const err = '请勾选'
        callback(err)
      }
    },
    downloadPsd () { },
    mutiUploadSuccess () {
      this.saveMaterialData()
    }
  },
  beforeRouteLeave (to, from, next) {
    const changeKey = []
    console.log(to)

    Object.keys(this.material).forEach((key) => {
      if (JSON.stringify(this.initMaterial[key]) !== JSON.stringify(this.material[key])) {
        changeKey.push(key)
      }
    })
    console.log(changeKey)
    if (changeKey.length > 0) {
      const that = this
      if (!this.clickSaveBtn) {
        this.$confirm({
          centered: true,
          content: '是否需要保存该素材',
          onOk () {
            that.save(to.fullPath)
          },
          cancelText: '取消',
          okText: '确定',
          onCancel () {
            that.clearMaterialLocal()
            next()
          }
        })
      } else {
        next()
      }
    } else {
      next()
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .card-upload img {
  max-height: inherit;
}

.card-preview-list {
  display: flex;

  .card-preview-item {
    margin-right: 40px;
    .title {
      font-size: 14px;
      color: #999999;
    }

    .card-preview-img {
      border: 1px solid #e5e5e5;
      height: 391px;
      position: relative;
      border-radius: 4px;
      overflow: hidden;
      img {
        position: absolute;
        top: 0;
        left: 0;
        height: auto;
        display: block;
      }
      .card-display {
        width: 259px;
        height: 151px;
        border-radius: 8px;
        overflow: hidden;
        margin: 50px auto 0;
        position: relative;
        img {
          width: 259px !important;
          position: absolute;
          top: -156px;
          left: 0px;
        }
      }
      &.card_1 {
        width: 220px;
        img {
          width: 220px;
        }
      }
      &.card_2 {
        width: 277px;
        img {
          width: 277px;
        }
      }
    }
  }
}

.download-psd {
  font-size: 12px;
  display: inline-block;
  vertical-align: middle;
  &:hover {
    text-decoration: underline;
  }
}
.showHelpUpload {
  .title {
    color: @primary-color;
    text-align: center;
    font-size: 24px;
  }

  .ant-modal-body {
    padding: 0 44px;
    color: #343434;
    font-size: 16px;
    p {
      line-height: 28px;
    }
    img {
      width: 100%;
      height: auto;
    }
    .content {
    }
    .btn-list {
      text-align: center;
      margin-top: 32px;
    }
  }
}
.help-box {
  position: relative;
  margin-left: 4px;
  .icon-left_help_16 {
    font-size: 12px;
    color: #aaaaaa;
  }
  &:hover {
    .tool-tips {
      display: block;
    }
    .icon-left_help_16 {
      color: #ff7401;
    }
  }

  .tool-tips {
    display: none;
    position: absolute;
    padding: 15px 20px 20px;
    z-index: 999;
    top: 50%;
    left: 28px;
    transform: translateY(-50%);
    background-color: rgba(255, 255, 255, 0.9);
    border: 1px solid #ff7401;
    border-radius: 8px;
    box-sizing: border-box;
    &::after {
      content: '';
      display: block;
      width: 0;
      height: 0;
      position: absolute;
      top: 50%;
      left: -10px;
      z-index: 9;
      transform: translateY(-50%);
      border-bottom: 12px solid transparent;
      border-right: 12px solid #ffffff;
      border-top: 12px solid transparent;
    }
    &::before {
      position: absolute;
      top: 50%;
      left: -12px;
      transform: translateY(-50%);
      content: '';
      display: block;
      z-index: 8;
      width: 0;
      height: 0;
      border-bottom: 12px solid transparent;
      border-right: 12px solid #ff7401;
      border-top: 12px solid transparent;
    }
    .tool-text {
      width: 386px;
      line-height: 24px;
      word-break: break-all;
      color: #333333;
      font-size: 14px;
      white-space: normal;
    }
    img {
      margin-top: 10px;
    }
  }
}
.upload-max {
  width: 120px;
  height: 120px;
  border-radius: 8px;
  overflow: hidden;
  background-image: url('../../assets/img/img_upload_120@2x.png');
  background-size: 100% 100%;
  background-color: #fafafa;
  border: 1px dashed #d9d9d9;
  cursor: pointer;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 99;
}
.help-content {
  img {
    display: inline-block;
    width: 100%;
    height: auto;
  }
  .title {
    color: @primary-color;
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 30px;
  }
  .desc {
    font-size: 14px;
    color: #999999;
    margin-bottom: 25px;
  }
  .img-list {
    display: flex;
    align-items: center;
    height: 200px;
    .img {
      max-width: 200px;

      margin-right: 25px;
      img {
        display: block;
        width: 100%;
        height: auto;
      }
    }
  }
}

.imageEditor {
  background-color: #ffffff;
  .ant-btn-link {
    color: @primary-color;
    background-color: transparent;
    border-color: transparent;
    -webkit-box-shadow: none;
    box-shadow: none;
  }
  .step {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 30px;
    border-bottom: 1px solid #f2f2f2;
    /deep/ .ant-steps-navigation .ant-steps-item-container {
      padding-bottom: 22px;
      padding-top: 22px;
      width: 100%;
      margin-left: 0;
    }
    /deep/ .ant-steps-item-icon {
      margin-right: 12px;
    }
    /deep/ .ant-steps-horizontal:not(.ant-steps-label-vertical) .ant-steps-item {
      margin-right: 156px;
    }
    /deep/ .ant-steps-navigation .ant-steps-item::after {
      margin-top: -8px;
      width: 116px;
      height: 6px;
      left: initial;
      right: -192px;
      background-image: url('../../assets/img/img_line_116_6@2x.png');
      background-size: 100% 100%;
      background-repeat: no-repeat;
      transform: none;
      border: none;
      transform: translateX(-50%);
    }
  }
  .step-box {
    background: #fff;
    padding: 40px 0px;
    min-height: 600px;

    .element-box {
      padding: 0 0 30px;
      border-bottom: 1px solid #f2f2f2;
      margin-bottom: 30px;
      .element-list {
        display: flex;
        .element-item {
          width: 120px;
          height: 120px;
          margin-right: 20px;
          text-align: center;
          box-sizing: border-box;
          position: relative;
          border-radius: 8px;
          border: 1px solid #f2f2f2;
          background-color: #fafafa;
          cursor: pointer;
          &.none {
            display: none;
          }
          &:hover {
            .mask {
              display: block;
              .del-btn {
                display: block;
                position: absolute;
                top: 3px;
                right: 3px;
                z-index: 9;
              }
            }
          }
          .mask {
            display: none;
            position: absolute;
            border-radius: 4px;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
            // background-color: rgba(0, 0, 0, 0);

            justify-content: flex-end;

            .del-btn {
              display: none;
              color: red;
              cursor: pointer;
            }
          }
          &.hasImg.active {
            border: 1px solid @primary-color;
          }
          &.active {
            // color: #1890ff;
            border: 1px dashed @primary-color;
            &::after {
              position: absolute;
              content: '';
              display: block;
              width: 100%;
              height: 2px;
              background-color: @primary-color;
              bottom: -32px;
              left: 0;
            }
            &::before {
              position: absolute;
              content: '';
              display: block;
              width: 10px;
              height: 4px;
              background-image: url('../../assets/img/icon_subscript_10_4@2x.png');
              background-size: 100% 100%;
              background-repeat: no-repeat;
              bottom: -36px;
              left: 50%;
              transform: translateX(-50%);
            }
          }
          .name {
            width: 100%;
            height: 30px;
            text-align: center;
            line-height: 30px;
            position: absolute;
            bottom: 0;
            left: 0;
            background-color: rgba(0, 0, 0, 0.5);
            color: #fff;
            border-radius: 0 0 8px 8px;
          }
          .cover {
            width: 100%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #bbbbbb;
            overflow: hidden;
            border-radius: 8px;
            img {
              display: block;
              border-radius: 8px;
              width: 100%;
              height: auto;
            }
          }
        }
        .add-btn {
          position: relative;
          width: 120px;
          min-height: 120px;
          border-radius: 8px;
          border: 1px solid rgba(229, 229, 229, 1);
          background-color: #f2f2f2;
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;
          background-image: url('../../assets/img/img_add_material_120@2x.png');
          background-size: 100% 100%;
          background-repeat: no-repeat;
          .text {
            position: absolute;
            bottom: 15px;
            font-size: 14px;
            width: 100%;
            text-align: center;
            color: #bbbbbb;
          }
          &:hover {
            border: 1px solid @primary-color;
          }
        }
      }
      .list-empty {
        width: 100%;
        margin-bottom: 40px;
        p {
          color: #999999;
        }
      }
    }

    #canvas {
      border: 1px solid #f2f2f2;
    }
    .step-btn-list {
      margin-left: 10px;
      margin-top: 18px;
      .next-step {
        margin-right: 20px;
        border-radius: 8px;
        padding: 0 19px;
        height: 40px;
        line-height: 40px;
        font-size: 16px;
      }
      .save {
        color: #999999;
        border: 1px solid #cccccc;
        font-size: 16px;
        border-radius: 8px;
        padding: 0 19px;
        height: 40px;
        line-height: 40px;
        &:hover {
          border-color: @primary-color;
        }
      }
    }

    .sale-input {
      width: 100px;
      margin-right: 20px;
    }
    .rate-group {
      height: auto;

      .ant-radio-wrapper {
        height: 40px;
        line-height: 40px;
        display: flex;
        flex-direction: row;
        align-items: center;
        .radio-label {
          display: inline-block;
          width: 150px;
        }
      }

    }

  }
  /deep/ .cover-item {
    .ant-form-item-children {
      display: flex;
      .cover-box {
        width: 120px;
        height: 120px;
        position: relative;
        overflow: hidden;
        &:hover {
          .mask {
            display: flex;
            .upload-btn {
              display: block;
            }
          }
        }
        .mask {
          display: none;
          border-radius: 4px;
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
          background-color: rgba(0, 0, 0, 0.5);

          justify-content: center;
          align-items: center;
          pointer-events: none;
          .upload-btn {
            display: none;
            pointer-events: none;
          }
        }
      }
      .tips {
        font-size: 12px;
        margin-left: 20px;
        p {
          margin: 0;
          line-height: 1;
          margin-bottom: 12px;
          color: #999999;
        }
      }
    }
  }

  .file-list {
    margin-top: 30px;
    .file-item {
      width: 200px;
      padding: 16px;
      border: 1px solid #f2f2f2;
      border-radius: 8px;
      position: relative;
      margin-top: 40px;
      margin-right: 42px;
      &.error {
        border: 1px solid #f5222d;
      }
      .image-view {
        width: 168px;
        height: 168px;
        margin-bottom: 12px;
        /deep/ .upload-img {
          border-radius: 4px;
        }
      }
      .name {
        height: 32px;
        font-size: 14px;
        color: #666666;
        input {
          border-color: #e5e5e5;
          &:focus {
            border-color: @primary-color;
          }
        }
      }
      .close {
        font-size: 24px;
        position: absolute;
        top: -12px;
        right: -12px;
        color: #d6d6d6;
        line-height: 1;
        &::before {
          background-color: #ffffff;
        }
        &:hover {
          color: @primary-color;
          cursor: pointer;
        }
      }
      .error-tips {
        position: absolute;
        bottom: -38px;
        left: 0;
        color: #f5222d;
        font-size: 12px;
        white-space: nowrap;
      }
    }
  }
}
</style>
